import React from 'react';

import { Layout } from 'pages/Layout';

import { CardApartmentContainer } from 'components/CardApartmentContainer';

import './homepage.scss';

const HomePage: React.FC = () => {
  return (
    <div>
      <Layout>
        <CardApartmentContainer />
      </Layout>
    </div>
  );
};

export default React.memo(HomePage);
